import { ReactComponent as PageLoadErrorImage } from '../../images/PageLoadErrorImage.svg'
import { PrimaryButton } from '../../buttons'
import { H1 } from '../../elements'
import { errorCss, descriptionCss } from '../errorCss'

const PageLoadError = () => (
  <div css={errorCss}>
    <PageLoadErrorImage aria-hidden="true" tabIndex={-1} />
    <H1>Page could not be loaded</H1>
    <p css={descriptionCss}>
      Please try again. If this problem persists, contact your system administrator.
    </p>
    <PrimaryButton onClick={() => window.location.reload()}>Refresh</PrimaryButton>
  </div>
)

export default PageLoadError
